import {
  FormInput,
  PaymentProcessorEnum,
  PrimaryButton,
  getPaymentProcessorTitle,
} from '@systemeio/ui'
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link'
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations'
import { razorpayConnect } from 'modules/profile/payment-gateways/integrations/razorpay/api'
import { PaymentRazorpayInterface } from 'modules/profile/payment-gateways/integrations/razorpay/types'
import { getRazorpayHelpPageLink } from 'modules/profile/payment-gateways/integrations/razorpay/utils'
import React, { useState } from 'react'
import CreateModal from 'shared/components/create-modal'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import { fetchWithErrors } from 'shared/utils/fetch-with-errors'

const defaultValues: PaymentRazorpayInterface = {
  apiKeyId: '',
  apiKeySecret: '',
}

const defaultErrors: PaymentRazorpayInterface = {
  apiKeyId: '',
  apiKeySecret: '',
}

const RazorpayCreateModal = () => {
  const { t } = useLocoTranslation()
  const { user } = useUser()
  const [opened, setOpened] = useState(false)
  const [errors, setErrors] = useState<PaymentRazorpayInterface>(defaultErrors)

  const { mutatePaymentIntegrations } = useConnectedPaymentIntegrations()

  const onCreate = async (data: PaymentRazorpayInterface) => {
    await fetchWithErrors(async () => {
      await razorpayConnect(data)
      await mutatePaymentIntegrations()
    }, setErrors)
  }
  return (
    <>
      <PrimaryButton
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault()
          setOpened(true)
        }}
        className={'font-bold'}
      >
        {t('dashboard.settings.payment_gateways.connect')}
      </PrimaryButton>
      <CreateModal
        fullCaption={t('dashboard.settings.payment_gateways.connect_payment_title', {
          payment: getPaymentProcessorTitle(PaymentProcessorEnum.Razorpay),
        })}
        opened={opened}
        onClose={() => setOpened(false)}
        defaultValues={defaultValues}
        needToast={false}
        creatable={[
          {
            field: 'apiKeyId',
            onRender: (value, onChange) => (
              <FormInput
                key={'razorpay-apiKeyId-create'}
                label={t('dashboard.settings.payment-gateways.api_key_id')}
                value={value}
                onChange={e => onChange(e.target.value)}
                error={errors.apiKeyId}
              />
            ),
          },
          {
            field: 'apiKeySecret',
            onRender: (value, onChange) => (
              <FormInput
                key={'razorpay-apiKeySecret-create'}
                label={t('dashboard.settings.payment-gateways.api_secret_key')}
                value={value}
                onChange={e => onChange(e.target.value)}
                error={errors.apiKeySecret}
              />
            ),
          },
        ]}
        additionalInfo={
          <HelpCenterLink
            link={getRazorpayHelpPageLink(user?.dashboardLocale)}
            integration={getPaymentProcessorTitle(PaymentProcessorEnum.Razorpay)}
          />
        }
        onCreate={onCreate}
        requiredFields={['apiKeyId', 'apiKeySecret']}
      />
    </>
  )
}

export default RazorpayCreateModal
